<template>
    <router-link
        :key="item.id"
        :to="`/shows/${item.hash}`"
        :class="[{'error': ! item.isValid}, 'item-link', 'list-item']"
    >
        <div class="container">
            <base-show-image
                v-if="! hideLabels"
                :show="item"
                :has-border="false"
                :size="size"
            />
            <template v-if="item.isValid">
                <a
                    v-if="hideLabels && hasUpgradePlans"
                    href="#"
                    class="link"
                    @click.prevent="upgradeToPro()"
                >
                    {{ upgradeLinkLabel }}
                </a>
                <show-label
                    :item="item"
                    :allowed-labels="allowedLabels"
                /><div
                    v-if="! hideLabels"
                    class="episodes-count"
                >
                    {{ item.episodeCount }} <span> {{ maybePluralize(item.episodeCount, 'Episode') }}</span>
                </div>
            </template>
            <template v-else>
                <i class="fa fa-exclamation error-icon" />
                <p class="error-message">
                    Can't read RSS
                </p>
            </template>
            <p class="title">
                {{ item.isValid ? item.title : 'Unknown' }}
            </p>
            <div class="icon-container">
                <base-icon
                    v-if="'list' === layout"
                    class="is-small"
                    icon="pencil-alt"
                />
                <div
                    v-if="hideLabels && ! item.isLifetime"
                    class="icon-wrapper"
                >
                    <base-tooltip
                        :class="['tooltipVisible']"
                    >
                        {{ !isDeleteDisabled() ? 'Delete show' : 'Email help@fusebox.fm' }}
                    </base-tooltip>
                    <base-icon
                        :class="[
                            { 'is-disabled': isDeleteDisabled() },
                            'is-small is-red',
                        ]"
                        icon="trash"
                        @click.native.prevent="removeShow()"
                    />
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import ShowLabel from './ShowLabel';
import {
    mapMutations,
    mapState,
} from 'vuex';
import { Step } from '@/utils/config/addShowModal';
import { getUpgradePlans } from '@/utils/plans';
import { steps as deleteSteps } from '@/utils/config/deleteShowModal';

export default {
    components: {
        ShowLabel,
    },

    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        layout: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: null,
        },
        hideLabels: {
            type: Boolean,
            default: false,
        },
        allowedLabels: {
            type: Array,
            default: null,
        },
    },

    data: () => ({
        deleteData: null,
    }),

    computed: {
        ...mapState([
            'user',
            'billingPlans',
            'userSubscription',
        ]),

        /**
         * Returns an array of upgrade plans.
         *
         * @returns {Array} Array of upgrade plans.
         */
        upgradePlans() {
            return this.billingPlans ? getUpgradePlans(this.item.plan, this.billingPlans) : [];
        },

        /**
         * Returns a single upgrade plan if there is only one.
         *
         * @returns {object|undefined} Single upgrade plan object.
         */
        singleUpgradePlan() {
            return 1 === this.upgradePlans.length
                ? this.upgradePlans[0] : undefined;
        },

        /**
         * Returns an upgrade link label
         *
         * @returns {string} Upgrade link label.
         */
        upgradeLinkLabel() {
            return this.singleUpgradePlan ? `Upgrade to ${this.singleUpgradePlan.name}` : 'Upgrade';
        },

        /**
         * Returns the flag determining if the show has upgrade plans.
         *
         * @returns {boolean} `true` if the show has upgrade plans, `false`
         *                    otherwise.
         */
        hasUpgradePlans() {
            return !! this.upgradePlans.length;
        },
    },

    /**
     * Created hook
     */
    created() {
        this.deleteData = {

        };
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Handle uprade to pro click
         *
         *
         */
        upgradeToPro() {
            this.changeUIState({
                addShowModal: {
                    mode: 'upgrade',
                    plan: this.singleUpgradePlan,
                    show: this.item,
                    step: Step.Plans,
                    type: this.item.hosted ? 'hosted' : 'feed',
                    visible: true,
                },
            });
        },

        /**
         * Handle remove button click
         *
         */
        removeShow() {
            this.$emit('remove-show', {
                step: this.removeShowStep(),
                showHash: this.item.hash,
            });
        },

        /**
         * Returns the first step of show removal.
         *
         * @returns {number} First step of show removal.
         */
        removeShowStep() {
            return this.item.hosted
                ? deleteSteps.copyFeedUrl
                : deleteSteps.delete;
        },

        /**
         * Pluralizes string.
         *
         * @param {number} number Number of episodes.
         * @param {string} string String to pluralize.
         * @returns {string}  Pluralized string if number greater then 1,
         *                    original string otherwise.
         */
        maybePluralize(number, string) {
            return 1 === number ? string : `${string}s`;
        },

        /**
         * Checks if button is disabled
         *
         * @returns  {boolean}  If is delete button disabled
         */
        isDeleteDisabled() {
            if (this.userSubscription?.cancel_at_period_end) {
                return true;
            }

            return false;
        },
    },
};
</script>
